import React from 'react'
import { useTranslation } from 'react-i18next'
import SolidButton from '@/component/button/SolidButton.tsx'
import BorderButton from '@/component/button/BorderButton.tsx'
import { MapType, useMapType } from '@/component/map/MapContext'
import { MapIcon } from '@/component/layout/ShellIcons.tsx'

const MAP_NAMES: Record<MapType, string> = { google: 'Google', baidu: 'Baidu' }

interface IProps {
    className?: string
    style?: React.CSSProperties
}

/** 지도 SDK 를 못 불러왔을 때 지도 자리에 보인다 */
const MapFallback: React.FC<IProps> = ({ className, style }) => {
    const { t } = useTranslation()
    const { mapType, setMapType } = useMapType()
    const otherType: MapType = mapType === 'google' ? 'baidu' : 'google'
    const names = { name: MAP_NAMES[mapType], other: MAP_NAMES[otherType] }

    return (
        <div className={`map-fallback ${className ?? ''}`} style={style}>
            <div className={'map-fallback__card'} role={'alert'}>
                <span className={'map-fallback__icon'}>
                    <MapIcon />
                </span>
                <strong>{t('map.fallback.title', names)}</strong>
                <p>{t('map.fallback.desc', names)}</p>
                <div className={'map-fallback__actions'}>
                    <SolidButton
                        size={'small'}
                        text={t('map.fallback.switch', names)}
                        onClick={() => setMapType(otherType)}
                    />
                    <BorderButton
                        size={'small'}
                        text={t('map.fallback.retry')}
                        onClick={() => window.location.reload()}
                    />
                </div>
            </div>
        </div>
    )
}

export default MapFallback
